import React, { useState } from 'react';
//comment
import _, { capitalize, find, isEmpty } from 'lodash';
import Grid from '@mui/material/Grid';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@mui/material';
import { Backdrop } from '@mui/material';
import { Box } from '@mui/material';
import { Modal } from '@mui/material';
import { Fade } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AddIcon from '@mui/icons-material/Add';
import Device from './Device';
import styles from './main.styles.js';
import AddDevice from './AddDevice';
import VideoList from './VideoList';
import axios from 'axios';
import AddMedication from './AddMedications';
import ShowMedications from './ShowMedications';
import { useTranslation } from 'react-i18next';
import CompanionCard from './CompanionCard';

const useStyles = makeStyles()(styles);
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '70%',
  bgcolor: 'background.paper',

  boxShadow: 24,
  p: 4,
};

const SUBSCRIPTION_TYPE = { device: 'DEVICE_PLAN', can_companion: 'CAN_COMPANION' };

function getDaysOld(date) {
  if (!date) {
    return 0;
  }
  // Get the current date
  var now = new Date();

  // Parse the input date string into a JavaScript Date object
  var inputDate = new Date(date);

  // Calculate the time difference in milliseconds
  var timeDifference = now - inputDate;

  // Convert milliseconds to days
  var daysOld = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  console.log(daysOld, date);
  if (daysOld > 365) {
    return 0;
  }

  return daysOld;
}

const updateSpiroTerms = async (userId) => {
  try {
    let results = await axios.put(
      `${process.env.REACT_APP_EXPRESS_URL}/api/users/spiro-terms/${userId}`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: localStorage.getItem('auth'),
        },
      },
    );
    console.log(results.data);
    if (results?.data.success) {
      return results.data.data;
    }
  } catch (e) {
    console.log(e);
  }
};

const STRIPE_SUB_STATUS = {
  paid: 'PAID',
  unpaid: 'UNPAID',
  trail: 'TRAIL',
};

function DeviceList({ user, refresh, userPortalSettings, medications, closeMedication, addCane, closeAddCane }) {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const [spiroModal, setSpiroModal] = React.useState(false);
  const [showMedicationTable, setShowMedicationTable] = React.useState(true);
  const [companionSubscription, setCompanionSubscription] = React.useState(null);

  React.useEffect(() => {
    if (!isEmpty(user)) {
      const data = find(user?.stripeInfo?.subscriptions, (i) => i.type === SUBSCRIPTION_TYPE.can_companion);
      setCompanionSubscription(data);
    }
  }, [user]);

  const [state, setState] = useState({
    openAddDevice: false,
    myDevices: null,
    caregiverDevices: null,
    openAddMeds: false,
  });
  console.log(
    'CAN YOU PLEASE CHECK HERE',
    !user?.spiroTerms?.agreed,
    user?.spiroTerms?.agreed,
    getDaysOld(user?.spiroTerms?.date || null),
  );
  const myDevices = state.myDevices || [];
  const caregiverDevices = state.caregiverDevices || [];

  let userName = user.username;
  if (user.userInfo && user.userInfo.firstName) {
    userName = `${user.userInfo.firstName} ${user.userInfo.lastName}`;
  }

  function closeModal() {
    setState({ openAddDevice: false });
  }

  let counter = 0;

  _.forEach(user.userTo, (device) => {
    counter += 1;
    let { deviceName } = device;

    if (!deviceName) {
      deviceName = `My Device ${counter}`;
    }

    let mainCaregiver = null;
    const caregiversOfDevice = _.filter(user.caregivers, (caregiver) => {
      if (caregiver.user === user.emergencyContact) {
        mainCaregiver = caregiver;
      }

      return caregiver.device === device.deviceId;
    });

    myDevices.push({
      id: device.deviceId,
      caregivers: caregiversOfDevice,
      mainCaregiver,
      name: deviceName,
      image: device.imageUrl,
    });
  });

  counter = 0;

  _.forEach(user.caregiverTo, (device) => {
    counter += 1;
    let { deviceName } = device;

    if (!deviceName) {
      deviceName = `Device ${counter}`;
    }

    caregiverDevices.push({
      id: device.device,
      user: device.user,
      name: deviceName,
      image: device.imageUrl,
    });
  });

  // can be used later
  // const updateTerms = async () => {
  //   let results = await updateSpiroTerms(user.id, user);
  //   user['spiroTerms'] = { agreed: true, date: results };
  //   refresh();
  // };

  return (
    <>
      <Grid
        container
        item
        direction="column"
        justify="flex-start"
        alignItems="flex-start"
        className={classes.deviceList}
        xs={12}
        sm={12}
        md={12}
        lg={8}
      >
        <Grid
          container
          item
          direction="row"
          justify="space-between"
          alignItems="center"
          className={classes.deviceListHeader}
        >
          <Grid
            container
            item
            direction="column"
            justify="center"
            alignItems="flex-start"
            className={classes.deviceHeaderTextContainer}
            xs={12}
            lg={12}
            md={12}
          >
            <Grid item className={classes.deviceListGreetings}>
              {t('hello')}, {capitalize(userName)}!
            </Grid>
            <Grid className={classes.deviceListMessage}>{t('welcome_message_description')}</Grid>
          </Grid>
        </Grid>
        <Dialog className={classes.modal} open={addCane} maxWidth={false}>
          <AddDevice user={user} closeModal={closeAddCane} refresh={refresh}></AddDevice>
        </Dialog>

        {userPortalSettings?.medicationReminder === 2 && (
          <Dialog className={classes.modal} open={medications} maxWidth={true}>
            {showMedicationTable ? (
              <ShowMedications
                closeModal={closeMedication}
                user={user}
                setShowMedicationTable={() => setShowMedicationTable((prev) => !prev)}
                refresh={refresh}
              />
            ) : (
              <AddMedication
                user={user}
                closeModal={closeMedication}
                refresh={refresh}
                setShowMedicationTable={() => setShowMedicationTable((prev) => !prev)}
              />
            )}
          </Dialog>
        )}

        {_.map(myDevices, (device) => {
          return (
            <Device
              device={device}
              user={user}
              relation={'my'}
              refresh={refresh}
              userPortalSettings={userPortalSettings}
            />
          );
        })}

        {_.map(caregiverDevices, (device) => {
          return (
            <Device
              device={device}
              user={user}
              relation={'caregiver'}
              refresh={refresh}
              userPortalSettings={userPortalSettings}
            />
          );
        })}

        {(companionSubscription?.subStatus === STRIPE_SUB_STATUS.paid ||
          companionSubscription?.subStatus === STRIPE_SUB_STATUS.trail) && <CompanionCard />}

        {/* {(user?.stripeInfo?.can_companion?.subStatus === STRIPE_SUB_STATUS.paid ||
          user?.stripeInfo?.can_companion?.subStatus === STRIPE_SUB_STATUS.trail) && <CompanionCard />} */}

        <h2
          onClick={() => {
            if (!user?.spiroTerms?.agreed) {
              return setSpiroModal(true);
            }
            console.log('still');
            if (getDaysOld(user?.spiroTerms?.date) > 30) {
              return setSpiroModal(true);
            }
          }}
          style={{ pointer: 'cursor' }}
        >
          {t('can_academy')}
        </h2>
        <VideoList title={t('how_to_use_cane')} category={3} />
        {
          // can be used later
          // <VideoList
          //   isSpiro={true}
          //   termsAgreed={user?.spiroTerms?.agreed}
          //   isOpen={!user?.spiroTerms?.agreed || (user?.spiroTerms?.agreed && getDaysOld(user?.spiroTerms?.date)) > 30}
          //   onAccept={updateTerms}
          //   refresh={refresh}
          //   title="Fall Prevention Exercises"
          //   category={2}
          // />
        }
      </Grid>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={spiroModal}
        onClose={() => setSpiroModal(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={spiroModal}>
          <Box sx={style}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              <span
                style={{
                  color: '#2F3C98',
                }}
              >
                SPIRO {t('terms_and_conditions')}
              </span>
            </Typography>
            <Typography style={{ paddingTop: '10px' }} id="transition-modal-description" sx={{ mt: 2 }}>
              {t('spiro_videos_para')}
            </Typography>
            <Button
              onClick={async () => {
                let results = await updateSpiroTerms(user.id, user);
                user['spiroTerms'] = { agreed: true, date: results };
                setSpiroModal(false);
              }}
              style={{ marginTop: '10px', color: '#2F3C98' }}
            >
              {t('agree')}
            </Button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default DeviceList;
